document.addEventListener('DOMContentLoaded', async () => {
  const form         = document.getElementById('js-profile-form');
  const emailEl      = document.getElementById('js-field-email');
  const editBtn      = document.getElementById('js-email-edit');
  const submitBtn    = document.getElementById('js-profile-submit');
  const cancelBtn    = document.getElementById('js-profile-cancel');
  const firstNameEl  = document.getElementById('js-field-first-name');
  const lastNameEl   = document.getElementById('js-field-last-name');
  const birthdayEl   = document.getElementById('js-field-birthday');
  const phoneEl      = document.getElementById('js-field-phone');
  const avatarPreview = document.getElementById('js-avatar-preview');

  const DEFAULT_AVATAR_SVG = avatarPreview.innerHTML;

  let original = { firstName: '', lastName: '', birthday: '', phone: '', email: '', avatar: null };
  let pendingAvatar = null; // base64 of new avatar, not yet saved

  function setDirty(dirty) {
    submitBtn.disabled = !dirty;
    cancelBtn.style.display = dirty ? 'inline-flex' : 'none';
  }

  function checkDirty() {
    const dirty =
      firstNameEl.value  !== original.firstName ||
      lastNameEl.value   !== original.lastName  ||
      (birthdayEl && birthdayEl.value !== original.birthday) ||
      (phoneEl && phoneEl.value !== original.phone) ||
      emailEl.value      !== original.email     ||
      pendingAvatar !== null;
    setDirty(dirty);
  }

  // Load profile
  try {
    const profile = await window.SKAuth.apiFetch('/api/customer/profile');
    firstNameEl.value = profile.firstName || '';
    lastNameEl.value  = profile.lastName  || '';
    if (birthdayEl) birthdayEl.value = profile.birthday || '';
    if (phoneEl) phoneEl.value = profile.phone || '';
    emailEl.value     = profile.email || '';
    original = {
      firstName: profile.firstName || '',
      lastName:  profile.lastName  || '',
      birthday:  profile.birthday  || '',
      phone:     profile.phone     || '',
      email:     profile.email || '',
      avatar:    profile.avatar || null,
    };
    if (profile.avatar) {
      avatarPreview.innerHTML = `<img src="${profile.avatar}" alt="Avatar">`;
    }
    localStorage.setItem('sk_profile', JSON.stringify({
      firstName: profile.firstName,
      lastName:  profile.lastName,
      email:     profile.email,
      avatar:    profile.avatar || null,
    }));
  } catch (err) {
    // AUTH errors already redirected to login; anything else (e.g. backend 500)
    // must not bounce to login, or a Shopify-side outage turns into a reload loop.
    if (err.code !== 'AUTH') window.SKAuth.showToast('Не вдалося завантажити профіль', 'error');
  }

  // Watch text fields for changes
  firstNameEl.addEventListener('input', checkDirty);
  lastNameEl.addEventListener('input', checkDirty);
  birthdayEl?.addEventListener('change', checkDirty);
  phoneEl?.addEventListener('input', checkDirty);
  emailEl.addEventListener('input', checkDirty);

  // Toggle email editable
  editBtn?.addEventListener('click', () => {
    const isReadonly = emailEl.hasAttribute('readonly');
    if (isReadonly) {
      emailEl.removeAttribute('readonly');
      emailEl.focus();
    } else {
      emailEl.setAttribute('readonly', '');
    }
  });

  // Save
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const body = {
        firstName: firstNameEl.value.trim(),
        lastName:  lastNameEl.value.trim(),
        birthday:  birthdayEl?.value || undefined,
        phone:     phoneEl?.value.trim() || undefined,
        email:     emailEl.value.trim(),
      };
      if (pendingAvatar) body.avatar = pendingAvatar;

      await window.SKAuth.apiFetch('/api/customer/profile', {
        method: 'PUT',
        body: JSON.stringify(body),
      });

      original.firstName = body.firstName;
      original.lastName  = body.lastName;
      original.birthday  = birthdayEl?.value || '';
      original.phone     = phoneEl?.value.trim() || '';
      original.email     = body.email;
      if (pendingAvatar) original.avatar = pendingAvatar;
      pendingAvatar = null;

      // Lock email back to readonly after save
      emailEl.setAttribute('readonly', '');

      localStorage.setItem('sk_profile', JSON.stringify({
        firstName: original.firstName,
        lastName:  original.lastName,
        email:     original.email,
        avatar:    original.avatar,
      }));

      // Update navbar popup in real-time
      const navName = document.getElementById('sk-header-name');
      const navEmail = document.getElementById('sk-header-email');
      const navAvatar = document.getElementById('sk-account-avatar');
      if (navName) navName.textContent = [original.firstName, original.lastName].filter(Boolean).join(' ') || 'Мій акаунт';
      if (navEmail) navEmail.textContent = original.email || '';
      if (navAvatar && original.avatar) {
        navAvatar.innerHTML = `<img src="${original.avatar}" alt="Avatar" style="width:28px!important;height:28px!important;max-width:28px!important;min-width:28px;border-radius:50%;object-fit:cover;display:block;">`;
      }

      setDirty(false);
      window.SKAuth.showToast('Зміни збережено');
    } catch (err) {
      window.SKAuth.showToast(err.message, 'error');
    }
  });

  // Cancel — restore original values
  cancelBtn.addEventListener('click', () => {
    firstNameEl.value = original.firstName;
    lastNameEl.value  = original.lastName;
    if (birthdayEl) birthdayEl.value = original.birthday;
    if (phoneEl) phoneEl.value = original.phone;
    pendingAvatar = null;
    if (original.avatar) {
      avatarPreview.innerHTML = `<img src="${original.avatar}" alt="Avatar">`;
    } else {
      avatarPreview.innerHTML = DEFAULT_AVATAR_SVG;
    }
    setDirty(false);
  });

  // Avatar — canvas resize, preview only; saved on submit
  document.getElementById('js-avatar-input')?.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = 150;
      canvas.height = 150;
      const ctx = canvas.getContext('2d');
      const min = Math.min(img.width, img.height);
      const sx = (img.width - min) / 2;
      const sy = (img.height - min) / 2;
      ctx.drawImage(img, sx, sy, min, min, 0, 0, 150, 150);
      pendingAvatar = canvas.toDataURL('image/jpeg', 0.75);
      avatarPreview.innerHTML = `<img src="${pendingAvatar}" alt="Avatar">`;
      checkDirty();
    };
    img.src = URL.createObjectURL(file);
  });
});
